/* @flow */

import { em } from 'polished';

import { aaDarkGrey, white } from '@e180/ui/lib/token/palette';

export default {
  root: {
    display: 'block',

    padding: [0, 0, em(0.5)],

    color: aaDarkGrey,

    fontSize: 16,
    fontWeight: 500,
    textDecoration: 'none',
    WebkitFontSmoothing: 'antialiased',

    '&:visited': {
      color: aaDarkGrey,
    },
    '&:hover': {
      color: white,
    },
    '&:active': {
      textDecoration: 'none',
    },
    '&:focus': {
      outlineWidth: 0,
    },
  },
};
